import { nanoid } from 'nanoid'

const createMock = (i, name) => ({
  id: nanoid(),
  name: `${name} ${i + 1}`
})

const createMockVal = val => ({
  id: nanoid(),
  ...val
})

export const MOCKS_YEAR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Год')
)

export const MOCKS_SUPERVISOR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Ответственный')
)

export const MOCKS_STATUS = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Статус')
)

export const MOCKS_IDPROJECT = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'ИД')
)

export const MOCKS_GENCONTRACTOR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Генподрядчик')
)

export const MOCKS_CONTRACT = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Договор')
)

export const MOCKS_CUSTOMER = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Заказчик')
)

export const MOCKS_DEVPPR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Разработчик ППР')
)

export const MOCKS_CONTRACTSUB = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Договор с субподрядчиком')
)

export const MOCKS_DEDUCTION = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'процент')
)

export const MOCKS_SUBCONTRACTOR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Субподрядчик')
)

export const MOCKS_TASKS = Array.from({ length: 10 }).map((_, i) =>
  createMockVal({
    name: `Заливка полов ${i + 1}`,
    descr: 'Заливка полов с 1 по 5 контур (Повседневная практика показывает, что постоянный количественный)...',
    supervisor: `Петр Петров ${i}`
  })
)

export const MOCKS_FILES = Array.from({ length: 8 }).map((_, i) =>
  createMockVal({
    name: `Документ ${i + 1}.PDF`,
    size: Math.random() * 1e7,
    url: '#'
  })
)

export const MOCKS_OBJ = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Объект')
)

export const MOCKS_TYPE = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Тип')
)

export const MOCKS_LETTERCUSTOMER = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Письмо заказчика')
)

export const MOCKS_LETTERCONTRACTOR = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Письмо подрядчика')
)

export const MOCKS_TYPE_JOBS = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Вид работ')
)
export const MOCKS_UNITS = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Единица измерения')
)
export const MOCKS_EXECUTORS = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Исполнитель')
)

export const MOCKS_DEVKMD = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Организация')
)

export const MOCKS_NOMENCLATURE_TYPE = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Номенклатура')
)

export const MOCKS_MONTH = Array.from({ length: 12 }).map((_, i) =>
  createMock(i, 'Месяц')
)

export const MOCKS_TYPE_PRODUCTION = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'БРУ')
)

export const MOCKS_TYPE_PRODUCT = Array.from({ length: 10 }).map((_, i) =>
  createMock(i, 'Бетон')
)
